'use strict';

module.exports = '3.7.4';
